import { success, error } from 'redux-saga-requests';
import {
  GET_MATERIALS,
  CREATE_MATERIAL,
  REMOVE_MATERIAL,
  UPDATE_MATERIAL,
} from './types';

const initialState = {
  materials: [],
  loading: false,
  error: null,
};

const getMaterialId = (material) => material?.id ?? material?.material_id;
const getMaterialsList = (data) => data?.materials ?? data ?? [];
const getMaterialPayload = (data) => data?.material ?? data;
const idsMatch = (left, right) => String(left) === String(right);

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MATERIALS:
    case CREATE_MATERIAL:
    case REMOVE_MATERIAL:
    case UPDATE_MATERIAL:
      return { ...state, error: null, loading: true };

    case success(GET_MATERIALS): {
      const materials = getMaterialsList(action.data);
      return {
        ...state,
        materials: Array.isArray(materials) ? materials : [],
        loading: false,
      };
    }

    case success(CREATE_MATERIAL): {
      const material = getMaterialPayload(action.data);
      return {
        ...state,
        materials: material && typeof material === 'object'
          ? [...state.materials, material]
          : state.materials,
        loading: false,
      };
    }

    case success(REMOVE_MATERIAL): {
      const materialId = action?.meta?.requestAction?.materialId;
      return {
        ...state,
        materials: state.materials.filter((material) => !idsMatch(getMaterialId(material), materialId)),
        loading: false,
      };
    }

    case success(UPDATE_MATERIAL): {
      const material = getMaterialPayload(action.data);
      const materialId = action?.meta?.requestAction?.materialId ?? getMaterialId(material);
      return {
        ...state,
        materials: state.materials.map((item) => (
          idsMatch(getMaterialId(item), materialId)
            ? { ...item, ...material }
            : item
        )),
        loading: false,
      };
    }

    case error(GET_MATERIALS):
    case error(CREATE_MATERIAL):
    case error(REMOVE_MATERIAL):
    case error(UPDATE_MATERIAL):
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default reducer;
